// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ma-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem 1rem;
  padding: 0 1.25rem 1rem;
}

.ma-search {
  width: 100%;
  max-width: 360px;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: #fff;
}

.ma-search:focus {
  outline: none;
  border-color: #0f766e;
}

.copy-trading-table .badge--contacted {
  background: #dbeafe;
  color: #1d4ed8;
}

.ma-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.65rem;
  padding: 2rem 1rem;
  color: #64748b;
  text-align: center;
}

.ma-toolbar {
  margin-bottom: 1rem;
}

.ma-back {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.45rem 0.9rem;
  font-size: 0.86rem;
  font-weight: 600;
  color: #0f766e;
  background: #fff;
  border: 1px solid rgba(15, 118, 110, 0.35);
  border-radius: 8px;
  text-decoration: none;
}

.ma-head {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: flex-start;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1rem 1.15rem;
  margin-bottom: 1rem;
}

.ma-head h2 {
  margin: 0 0 0.35rem;
}

.ma-head p {
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  color: #64748b;
}

.ma-note {
  margin: 0 0 1rem;
  padding: 0.85rem 1rem;
  border-radius: 12px;
  background: #f0fdfa;
  border: 1px solid #99f6e4;
  color: #134e4a;
  font-size: 0.86rem;
  line-height: 1.5;
}

.ma-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
  margin-bottom: 1rem;
}

.ma-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1rem 1.1rem;
}

.ma-card h3 {
  margin: 0 0 0.85rem;
  font-size: 0.92rem;
}

.ma-dl {
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 0.45rem 0.75rem;
  margin: 0;
  font-size: 0.86rem;
}

.ma-dl dt {
  color: #64748b;
  font-weight: 600;
}

.ma-dl dd {
  margin: 0;
  color: #0f172a;
  word-break: break-word;
}

.ma-message {
  white-space: pre-wrap;
  margin: 0;
  line-height: 1.5;
}

.ma-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.ma-status-form {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1rem 1.1rem;
  margin-bottom: 1rem;
}

.ma-status-form h3 {
  margin: 0 0 0.75rem;
  font-size: 0.92rem;
}

.ma-status-form label {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  font-size: 0.78rem;
  font-weight: 700;
  color: #64748b;
  margin-bottom: 0.75rem;
}

.ma-status-form textarea,
.ma-status-form select {
  font: inherit;
  font-weight: 500;
  color: #0f172a;
  padding: 0.5rem 0.7rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.ma-status-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-bottom: 0.85rem;
}

@media (max-width: 640px) {
  .ma-dl {
    grid-template-columns: 1fr;
  }

  .ma-head {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/CopyTrading/MasterApplicationsPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,oBAAoB;EACpB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".ma-filters {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 0.75rem 1rem;\n  padding: 0 1.25rem 1rem;\n}\n\n.ma-search {\n  width: 100%;\n  max-width: 360px;\n  padding: 0.5rem 1rem;\n  font-size: 0.9rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: #fff;\n}\n\n.ma-search:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.copy-trading-table .badge--contacted {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.ma-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.65rem;\n  padding: 2rem 1rem;\n  color: #64748b;\n  text-align: center;\n}\n\n.ma-toolbar {\n  margin-bottom: 1rem;\n}\n\n.ma-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  padding: 0.45rem 0.9rem;\n  font-size: 0.86rem;\n  font-weight: 600;\n  color: #0f766e;\n  background: #fff;\n  border: 1px solid rgba(15, 118, 110, 0.35);\n  border-radius: 8px;\n  text-decoration: none;\n}\n\n.ma-head {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  align-items: flex-start;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 1rem 1.15rem;\n  margin-bottom: 1rem;\n}\n\n.ma-head h2 {\n  margin: 0 0 0.35rem;\n}\n\n.ma-head p {\n  margin: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  color: #64748b;\n}\n\n.ma-note {\n  margin: 0 0 1rem;\n  padding: 0.85rem 1rem;\n  border-radius: 12px;\n  background: #f0fdfa;\n  border: 1px solid #99f6e4;\n  color: #134e4a;\n  font-size: 0.86rem;\n  line-height: 1.5;\n}\n\n.ma-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.ma-card {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 1rem 1.1rem;\n}\n\n.ma-card h3 {\n  margin: 0 0 0.85rem;\n  font-size: 0.92rem;\n}\n\n.ma-dl {\n  display: grid;\n  grid-template-columns: 140px 1fr;\n  gap: 0.45rem 0.75rem;\n  margin: 0;\n  font-size: 0.86rem;\n}\n\n.ma-dl dt {\n  color: #64748b;\n  font-weight: 600;\n}\n\n.ma-dl dd {\n  margin: 0;\n  color: #0f172a;\n  word-break: break-word;\n}\n\n.ma-message {\n  white-space: pre-wrap;\n  margin: 0;\n  line-height: 1.5;\n}\n\n.ma-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.ma-status-form {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 1rem 1.1rem;\n  margin-bottom: 1rem;\n}\n\n.ma-status-form h3 {\n  margin: 0 0 0.75rem;\n  font-size: 0.92rem;\n}\n\n.ma-status-form label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: #64748b;\n  margin-bottom: 0.75rem;\n}\n\n.ma-status-form textarea,\n.ma-status-form select {\n  font: inherit;\n  font-weight: 500;\n  color: #0f172a;\n  padding: 0.5rem 0.7rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n}\n\n.ma-status-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  margin-bottom: 0.85rem;\n}\n\n@media (max-width: 640px) {\n  .ma-dl {\n    grid-template-columns: 1fr;\n  }\n\n  .ma-head {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
